<template>
  <label
    class="flex gap-3 py-1.5 transition"
    :class="[isDisabled && `opacity-50`]"
  >
    <input
      :id="inputId"
      ref="input"
      v-model="radioGroupContext.modelValue.value"
      type="radio"
      :name="radioGroupContext.name.value"
      :value="value"
      :disabled="isDisabled"
      class="my-0.5 size-4 rounded-full border-border bg-input text-blue-600 focus:ring-blue-500"
      v-bind="$attrs"
    />

    <span class="text-sm">
      <slot />
    </span>
  </label>
</template>

<script lang="ts" setup>
import { computed, onWatcherCleanup, useId, useTemplateRef, watch } from "vue";

import { injectRadioGroupContext } from "./context";

defineOptions({
  inheritAttrs: false,
});

const props = defineProps<{
  value: string;
  disabled?: boolean;
}>();

const radioGroupContext = injectRadioGroupContext();

const inputId = useId();
const input = useTemplateRef("input");

const isDisabled = computed(() => {
  return radioGroupContext.disabled.value || props.disabled;
});

watch(input, (inputEl) => {
  if (!inputEl) {
    return;
  }

  radioGroupContext.inputElements.add(inputEl);

  onWatcherCleanup(() => {
    radioGroupContext.inputElements.delete(inputEl);
  });
});

defineExpose({ input });
</script>
